import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class PrintApi {
    static updateBulkImages(eventID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/print`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/print.js